<template>
    <div :class="{ 'row m-0': small }">
        <div
            class="custom-control custom-checkbox remove-padding m-t-8"
            :class="{ 'col-md-6 col-sm-6 col-6 p-0': small }"
        >
            <div class="custom-control custom-switch">
                <input
                    class="custom-control-input"
                    type="checkbox"
                    :id="checkId"
                    :name="nama"
                    :disabled="disabled"
                    :checked="checked"
                    @change="toggle"
                    v-model="checked"
                />
                <label
                    class="custom-control-label label-checklist"
                    :for="checkId"
                    :class="{ 'text-bold': bTitle }"
                    v-html="checkTitle"
                >
                </label>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SOToggleOnOff",
    props: {
        checkId: {
            type: String,
            required: true,
        },
        checkTitle: {
            type: String,
            required: true,
        },
        nama: {
            type: String,
            required: true,
        },
        bTitle: {
            type: Boolean,
            default: false,
        },
        small: {
            type: Boolean,
            default: false,
        },
        isChecked: {
            type: Boolean,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            checked: this.isChecked,
        };
    },
    watch: {
        isChecked: function(nc, oc) {
            if (nc !== oc) {
                this.checked = nc;
            }
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        toggle(obj) {
            this.$emit("selected", this.checked);
        },
        init() {
            this.checked = this.isChecked;
        },
    },
};
</script>

<style scoped>
.text-bold {
    font-weight: bold;
}

.custom-control {
    padding-left: 0;
}
.custom-switch {
    padding-left: 1rem;
}
</style>
